import { useAppSelector } from "../../hooks/StoreHooks";

export const useSubCompaniesData = () =>
  useAppSelector((state) => state.subCompanies.subCompaniesData);

export const useEditedSubCompaniesData = () =>
  useAppSelector((state) => state.subCompanies.editedSubCompaniesData);

export const useOnSubCompaniesSave = () =>
  useAppSelector((state) => state.subCompanies.onSave);

export const useSubCompanyEmployees = (subCompanyId: number) =>
  useAppSelector((state) => state.subCompanies.subCompanyEmployees[subCompanyId] ?? []);